import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";

export interface BreadCrumbItem {
  label: string;
  path: string;
}

interface BreadCrumbProps {
  title: string;
  pageTitle: string;
  /**
   * Optional breadcrumb trail. Multiple segments (e.g. "Organizations" → "Edit Organization").
   * The current page (title) is appended as the last segment.
   */
  items?: BreadCrumbItem[];
  /** Optional single back link. Ignored if `items` is provided. */
  backTo?: BreadCrumbItem;
}

const BreadCrumb = ({ title, pageTitle, items, backTo }: BreadCrumbProps) => {
  const navigate = useNavigate();
  const segments = items ?? (backTo ? [backTo] : []);

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              {segments.length > 0 && (
                <>
                  {/* <Link
                    to={segments[0].path}
                    className="text-muted text-decoration-none d-inline-flex align-items-center fs-13"
                  >
                    <i className="ri-arrow-left-line me-1"></i>
                    {segments[0].label}
                  </Link> */}
                  <button
                    type="button"
                    className="btn btn-icon btn-sm btn-ghost-dark rounded-circle d-inline-flex align-items-center justify-content-center"
                    onClick={() => navigate(-1)}
                    aria-label="Go back"
                  >
                    <i className="ri-arrow-left-line fs-16 "></i>
                  </button>
                  {segments.slice(1).map((item, i) => (
                    <React.Fragment key={item.path + i}>
                      {i > 0 && <span className="text-muted fs-13">/</span>}
                      <Link
                        to={item.path}
                        className="text-muted text-decoration-none d-inline-flex align-items-center fs-13"
                      >
                        {item.label}
                      </Link>
                    </React.Fragment>
                  ))}
                </>
              )}
              <h4 className="mb-0">{title}</h4>
            </div>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                {segments.length > 0 ? (
                  <>
                    {segments.map((item, i) => (
                      <li key={item.path + i} className="breadcrumb-item">
                        <Link to={item.path}>{item.label}</Link>
                      </li>
                    ))}
                    <li className="breadcrumb-item active">{title}</li>
                  </>
                ) : (
                  <>
                    <li className="breadcrumb-item">
                      <Link to="#">{pageTitle}</Link>
                    </li>
                    <li className="breadcrumb-item active">{title}</li>
                  </>
                )}
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
